import _toConsumableArray from "/Users/ahmerafzal/Documents/Work/Brandripplr/v2/project/brandripplr/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "flex flex-column gap-3 mb-3"
};
var _hoisted_2 = {
  key: 0,
  class: "w-full flex align-items-center flex-column p-4"
};
var _hoisted_3 = {
  key: 1,
  class: "w-full flex align-items-center flex-column p-4"
};
var _hoisted_4 = {
  key: 2,
  class: "w-full"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "mr-4 md:mr-8"
};
var _hoisted_7 = {
  class: "flex"
};
var _hoisted_8 = {
  class: "ml-2"
};
var _hoisted_9 = {
  class: "font-medium mb-1"
};
var _hoisted_10 = {
  class: "text-sm"
};
var _hoisted_11 = {
  class: "flex gap-3 justify-content-end border-top-1 surface-border pt-5"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_InputIcon = _resolveComponent("InputIcon");
  var _component_InputText = _resolveComponent("InputText");
  var _component_IconField = _resolveComponent("IconField");
  var _component_ProgressSpinner = _resolveComponent("ProgressSpinner");
  var _component_RadioButton = _resolveComponent("RadioButton");
  var _component_Avatar = _resolveComponent("Avatar");
  var _component_Button = _resolveComponent("Button");
  var _component_Dialog = _resolveComponent("Dialog");
  return _openBlock(), _createBlock(_component_Dialog, {
    visible: $data.selectBrandDialog.showDialog,
    "onUpdate:visible": _cache[4] || (_cache[4] = function ($event) {
      return $data.selectBrandDialog.showDialog = $event;
    }),
    appendTo: "body",
    modal: "",
    breakpoints: {
      '960px': '55vw',
      '640px': '90vw'
    },
    style: {
      width: '40vw'
    },
    header: "Select Brand",
    draggable: false,
    resizable: false,
    closable: false
  }, {
    header: _withCtx(function () {
      return _toConsumableArray(_cache[5] || (_cache[5] = [_createElementVNode("div", {
        class: "flex flex-column gap-2"
      }, [_createElementVNode("h1", {
        class: "m-0 text-900 font-semibold text-xl line-height-3"
      }, "Select Brand")], -1)]));
    }),
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_11, [_createVNode(_component_Button, {
        label: "Cancel",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return $data.selectBrandDialog.showDialog = false;
        }),
        class: "p-button-text"
      }), _createVNode(_component_Button, {
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return $options.changeCurrentBrand();
        }),
        label: "Select",
        class: "p-button-rounded",
        loading: $data.loading,
        disabled: $data.count == 0
      }, null, 8, ["loading", "disabled"])])];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_IconField, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_InputIcon, {
            class: "pi pi-search"
          }), _createVNode(_component_InputText, {
            class: "w-full",
            type: "text",
            modelValue: $data.filter.search_brand_name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return $data.filter.search_brand_name = $event;
            }),
            placeholder: "Search Brand",
            onInput: $data.searchBrand
          }, null, 8, ["modelValue", "onInput"]), $data.search_loading ? (_openBlock(), _createBlock(_component_InputIcon, {
            key: 0,
            class: "pi pi-spin pi-spinner"
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      })]), !$data.data_loaded ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_ProgressSpinner, {
        strokeWidth: "1"
      }), _cache[6] || (_cache[6] = _createElementVNode("span", {
        class: "mt-2"
      }, "Please wait...", -1))])) : _createCommentVNode("", true), $data.data_loaded && $data.count == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toConsumableArray(_cache[7] || (_cache[7] = [_createElementVNode("i", {
        class: "pi pi-briefcase mb-2",
        style: {
          "font-size": "2rem"
        }
      }, null, -1), _createElementVNode("span", null, "No brands found", -1)])))) : _createCommentVNode("", true), $data.data_loaded ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.brands, function (brand) {
        return _openBlock(), _createElementBlock("div", {
          key: brand.id,
          class: _normalizeClass(["surface-card border-1 p-3 flex border-round mb-1 align-items-center cursor-pointer", {
            'surface-border': $data.selectBrandDialog.selectedBrandId != brand.id,
            'border-primary': $data.selectBrandDialog.selectedBrandId == brand.id
          }]),
          onClick: function onClick($event) {
            return $options.selectBrand(brand);
          }
        }, [_createVNode(_component_RadioButton, {
          name: "selectedBrand",
          modelValue: $data.selectBrandDialog.selectedBrandId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
            return $data.selectBrandDialog.selectedBrandId = $event;
          }),
          value: brand.id,
          class: "mr-3"
        }, null, 8, ["modelValue", "value"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_Avatar, {
          size: "large",
          shape: "circle",
          image: brand.logo ? brand.logo : null
        }, null, 8, ["image"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(brand.brand_name), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(brand.company.company_name), 1)])])])], 10, _hoisted_5);
      }), 128))])) : _createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["visible"]);
}